<template>
  <div class="welcome">
    <div v-if="showDiscountWelcomeImage" class="image-wrapper">
      <img class="image-container" :src="require('@/assets/onboarding-discount.png')">
    </div>
    <div v-else class="image-wrapper">
      <img class="image-container" :src="require('@/assets/introduction/kikar-header.svg')">
    </div>
    <div class="page-content">
      <div class="description">
        <div class="title">{{  title }}</div>
        <div class="subtitle">נעים מאוד, נתחיל עם <span class="bold">4 שאלות</span> שיעזרו לנו להכיר אותך טוב יותר.</div>
      </div>
      <div class="bottom-page">
        <div class="button-container">
          <riseup-button class="button-to-signup" :title="'אפשר להתחיל'" :size="'small'" :action="goToLQ"/>
        </div>
        <div class="already-registered">
          כבר הצטרפת לשירות?
          <span class="enter" v-on:click="goToHome">הכניסה מכאן</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BaseUI from 'base-ui';
import router from '../../../../router';
import Segment from '../../../../Segment';
import questions from './lead-qualification/consts/questions';

export default {
  name: 'Welcome',
  components: {
    RiseupButton: BaseUI.RiseupButton,
  },
  props: {
    referralData: {
      type: Object,
    },
    showDiscountWelcomeImage: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    title() {
      if (this.referralData) {
        const { householdName } = this.referralData;
        return `אלפי לקוחות כבר מנצחים את החודש עם riseup. ${householdName} כבר בפנים, עכשיו תורך!`;
      }
      return 'אלפי לקוחות כבר מנצחים את החודש עם riseup. עכשיו תורך!';
    },
  },
  methods: {
    ...mapActions('signup', ['setUtmParams']),
    async goToLQ() {
      Segment.trackUserInteraction('SignupClicked');
      Segment.trackUserInteractionToPixel('SC');
      router.push({ path: `signup/lq/question/${questions.QUESTION_NAMES.FINANCIAL_CONTROL}` });
    },
    async goToHome() {
      router.push({ path: '/sr' });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../scss/mixins';

  .welcome {
    @include white-page-frame;
    height: 100%;

    .image-wrapper {
      width: 100%;
      .image-container {
        width: 100%;
      }
    }

    .page-content {
      @include responsive-padding;
      margin-top: 30px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .description {
        .title {
          font-size: 22px;
          line-height: 1.27;
          width: 100%;
          margin-bottom: 15px;
          font-weight: bold;
        }

        .subtitle {
          font-size: 18px;
          line-height: 1.5;

          .bold {
            font-weight: bold;
          }
        }
      }

      .button-container {
        @include responsive-padding-top-bottom;

        .button-to-signup {
          width: 100%;
          white-space: nowrap;
        }
      }

      .already-registered {
        margin-bottom: 30px;
        color: $riseup_light_blue;
        text-align: center;

        .enter {
          font-weight: bold;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }

</style>
